module.exports = __webpack_public_path__ + "/images/cover-cta-caja-yellow.3bc1056.jpg";